import React from 'react'

const ArrowRightAngle = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="5" height="7" viewBox="0 0 5 7" fill="none">
            <path d="M0.629908 6.38142C0.543303 6.30237 0.5 6.20877 0.5 6.10063C0.5 5.9927 0.543303 5.89921 0.629908 5.82016L3.16744 3.50395L0.621247 1.17984C0.540416 1.10606 0.5 1.01383 0.5 0.903162C0.5 0.79249 0.543303 0.697628 0.629908 0.618577C0.716513 0.539526 0.819053 0.5 0.937529 0.5C1.05577 0.5 1.1582 0.539526 1.2448 0.618577L4.15474 3.28261C4.18938 3.31423 4.21397 3.34848 4.22852 3.38538C4.24284 3.42227 4.25 3.46179 4.25 3.50395C4.25 3.54611 4.24284 3.58564 4.22852 3.62253C4.21397 3.65942 4.18938 3.69368 4.15474 3.7253L1.23614 6.38933C1.15531 6.46311 1.05577 6.5 0.937529 6.5C0.819053 6.5 0.716513 6.46047 0.629908 6.38142Z" fill="#1111AA" />
        </svg>
    )
}

export default ArrowRightAngle